import { BLOG_ROUTE, CONSUMER_NAME_ROUTE, LEARN_ROUTE, PRESS_ROUTE } from 'constants/navigation'
import { ogIncludeMetaTypeArticleArray } from 'constants/metaTags'
import { getArticleImage, getHeroImage, getPressImage } from './file'
import SITE_ENVIRONMENTS from 'constants/websites'
import { fetchLogoImage } from 'services/contentful/helpers'
import { rewriteAssetUrl } from '../conversions'

const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT

const getTwitterImage = async (route, children) => {
  switch (siteEnv) {
    case SITE_ENVIRONMENTS.ACHIEVE:
      switch (route) {
        case 'home-equity-loan':
        case 'personal-loans':
        case 'debt-relief':
          return getHeroImage(children)
        case 'learn':
          return getArticleImage(children)
        case 'about':
          return getPressImage(children)
        default:
          return getHeroImage(children)
      }

    case SITE_ENVIRONMENTS.FDR: {
      const imageFdr = await fetchLogoImage({}, '53Ppkp2KFG09dGb5lXbw2')
      const rewrittenUrl = rewriteAssetUrl(imageFdr?.fields?.file?.url)
      return rewrittenUrl
    }

    case SITE_ENVIRONMENTS.BILLS: {
      return getHeroImage(children)
    }

    default:
      // TODO other sites can have their own logic here
      return getHeroImage(children)
  }
}

const getOgImageAlt = () => {
  switch (siteEnv) {
    case SITE_ENVIRONMENTS.FDR:
      return 'Freedom Debt Relief Client'
    case SITE_ENVIRONMENTS.BILLS:
      return 'Bill'
    case SITE_ENVIRONMENTS.FFN:
      return 'Freedom Financial Network'
    case SITE_ENVIRONMENTS.WFS:
      return 'Weekly Financial Solution'
    default:
      return 'Achieve'
  }
}
const getOgTypeMetaTag = (route) => {
  const normalizedRoute = route.replace(/^\/+/, '')
  switch (siteEnv) {
    case SITE_ENVIRONMENTS.FDR:
      // TODO improve base on article logic
      return 'website'
    case SITE_ENVIRONMENTS.ACHIEVE: {
      const routeSegments = normalizedRoute.split('/').filter(Boolean)
      if (
        ogIncludeMetaTypeArticleArray.some((articleRoute) =>
          articleRoute === 'learn'
            ? routeSegments[0] === articleRoute && routeSegments.length === 3
            : normalizedRoute === articleRoute || normalizedRoute.startsWith(`${articleRoute}/`)
        )
      ) {
        return 'article'
      } else {
        return 'website'
      }
    }
    default:
      return 'website'
  }
}

const getPaginatedPageCanonicalLink = (link) => {
  if (!link) return
  const canonicalLinkQueryIndex = link.indexOf('?')
  return canonicalLinkQueryIndex !== -1 ? link.substring(0, canonicalLinkQueryIndex) : link
}

const getPageMetaTitleForRoute = (dynamicPathname, pageMetaTitle, pageTitle) => {
  const path = dynamicPathname.split('/[')?.[0]
  let title = pageMetaTitle
  if (path == '/404') {
    return 'Page Not Found'
  }
  if (path == '/503') {
    return 'Maintenance Mode'
  }
  if (path == '/500') {
    return 'Internal Server Error'
  }
  if (pageTitle)
    switch (path) {
      case LEARN_ROUTE:
      case CONSUMER_NAME_ROUTE:
      case BLOG_ROUTE:
      case PRESS_ROUTE:
        title = pageTitle
        break
    }
  return title
}
const getSiteName = () => {
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT
  let siteName
  let twitterSite
  switch (siteEnv) {
    case SITE_ENVIRONMENTS.WFS:
      siteName = 'Weekly Financial Solution'
      twitterSite = 'weeklyfinancialsolutions'
      break
    case SITE_ENVIRONMENTS.FDR:
      siteName = 'Freedom Debt Relief'
      twitterSite = 'freedomdebtrelief'
      break
    case SITE_ENVIRONMENTS.FFN:
      siteName = 'Freedom Financial Network'
      twitterSite = 'freedomfinancialnetwork'
      break
    case SITE_ENVIRONMENTS.BILLS:
      siteName = 'Bills.com'
      twitterSite = 'bills'
      break
    default:
      siteName = 'Achieve'
      twitterSite = 'achieve'
  }
  return {
    siteName,
    twitterSite: `@${twitterSite}.com`,
  }
}
export {
  getTwitterImage,
  getOgTypeMetaTag,
  getPaginatedPageCanonicalLink,
  getPageMetaTitleForRoute,
  getSiteName,
  getOgImageAlt,
}
